import { getRouteApi } from "@tanstack/react-router";
import { Search, X } from "lucide-react";
import { useState } from "react";
import { useDebounce } from "react-use";
import { Input } from "@/components/ui/input";

const routeApi = getRouteApi("/(authed)/_layout/contacts");

interface SearchFilterProps {
  handleResetPagination: () => void;
}

export function SearchFilter({ handleResetPagination }: SearchFilterProps) {
  const navigate = routeApi.useNavigate();
  const searchParams = routeApi.useSearch();
  const [searchTerm, setSearchTerm] = useState(searchParams.search || "");

  useDebounce(
    () => {
      handleResetPagination();
      void navigate({ search: (prev) => ({ ...prev, search: searchTerm || undefined }) });
    },
    300,
    [searchTerm],
  );

  const handleClear = () => {
    setSearchTerm("");

    handleResetPagination();
    void navigate({ search: (prev) => ({ ...prev, search: undefined }) });
  };

  return (
    <div className="relative flex-1 max-w-sm">
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        id="contacts-search"
        name="contacts-search"
        placeholder="Search contacts"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="pl-10 pr-8"
        autoComplete="off"
      />
      {searchTerm ? (
        <button
          type="button"
          onClick={handleClear}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
        >
          <X className="h-4 w-4" />
        </button>
      ) : null}
    </div>
  );
}
